export default {
  path: '/record',
  meta: {
    title: '使用记录',
  },
  component: r => require.ensure([], () => r(require(`./index.vue`)), `/record`),
}



// WEBPACK FOOTER //
// ./src/views/Record/router.js